<template>
  <q-item
    :clickable="clickable || hasMenuContent"
    :class="{'q-pa-none invisible-item': !simple, 'q-pa-sm': simple, 'bg-grey-2': !!morph, 'q-my-md': !simple && !slim, 'q-my-sm': !(!simple && !slim)}"
    class="timeline-card break-word"
    @click="$emit('click')"
  >
    <q-icon
      v-if="pinned && simple"
      name="mdi-pin"
      class="absolute-top-left rotate-315 no-pointer-events"
      color="blue-7"
      style="left: -6px; top: -6px;"
    />

    <slot />

    <q-item-section
      v-if="hasMenuContent || !!morph"
      side
    >
      <q-icon
        :name="!!morph ? 'mdi-link-lock' : 'mdi-dots-vertical'"
        :size="!!morph ? '1.2em' : '1.1em'"
      />
    </q-item-section>

    <responsive-menu
      v-if="hasMenuContent"
      ref="menu"
      fit
      force-on-mobile
      toolbar-title="Details"
      card-style="width: 100%; min-width: 300px;"
    >
      <template #default="{ mobileMode }">
        <q-list :dense="!mobileMode">
          <q-item v-if="mobileMode">
            <slot />
          </q-item>
          <q-list v-if="morph">
            <q-item-wrapper
              icon="mdi-link-lock"
              :clickable="!!morph.url"
              @click="goTo(morph.url)"
            >
              <q-item-label style="max-width: 600px;">
                {{ morph.name }}
              </q-item-label>
              <q-item-label
                v-if="morph.reference"
                caption
                class="q-mb-xs"
              >
                {{ morph.reference }}
              </q-item-label>
              <q-item-label caption>
                Collated via {{ morph.type }}
              </q-item-label>
              <template v-if="morph.url" #after>
                <q-item-section side>
                  <q-btn
                    round
                    flat
                    icon="mdi-arrow-right"
                  />
                </q-item-section>
              </template>
            </q-item-wrapper>
          </q-list>
          <q-separator
            v-if="morph || mobileMode"
            inset
            class="q-my-sm"
          />
          <slot name="menu" />
        </q-list>
      </template>
    </responsive-menu>
  </q-item>
</template>

<script>
export default {
  props: {
    clickable: {
      type: Boolean,
      default: false
    },
    pinned: {
      type: Boolean,
      default: false
    },
    morph: {
      type: Object,
      default: null
    },
    slim: {
      type: Boolean,
      default: false
    },
    // Simple Timeline - show as tranditional card
    simple: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  computed: {
    hasMenuContent () {
      return !!this.$slots.menu
    }
  }
}
</script>
